module.exports = __webpack_public_path__ + "static/media/arrow-circle-left.248203af.svg";